import { Row, Col } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';

type Props = {
  name: string;
  detail?: any;
  noBorder?: boolean;
  active?: boolean;
  form: string;
  type?: string;
  size?: string;
  number?: boolean;
};

const Wrap = styled.div`
  && {
    .boxItem {
      border-bottom: 1px solid #dddddd;
      padding: 15px 10px;
    }
    .noBorder {
      padding: 15px 10px;
    }
    .disable {
      color: rgba(196, 196, 196, 1);
    }
    .ml-24 {
      margin-left: 24px;
    }
    .bar {
      height: 20px;
    }
  }
`;

const Model: FC<Props> = ({
  number = true,
  name,
  detail,
  noBorder = false,
  active = true,
  form = 'model' || 'accessories',
  type,
  size,
}) => {
  return (
    <Wrap>
      <div className={active === false ? 'disable' : ''}>
        <Row className={noBorder === false ? 'boxItem' : 'noBorder'}>
          <Col span={8} className="standardBoldFont d-flex alignCenter">
            {name}
          </Col>
          <Col span={2} className="standardFont d-flex alignCenter">
            機番
          </Col>
          {form === 'model' ? (
            <Col span={14} className="standardBoldFont d-flex alignCenter">
              {detail}
            </Col>
          ) : (
            <>
              <Col className="standardFont d-flex alignCenter" span={2}>
                {type}
              </Col>
              <Col className="standardFont d-flex alignCenter" span={3}>
                <div className="bar" />
                サイズ
              </Col>
              <Col span={3} className="mb-0 standardBoldFont">
                {size}
              </Col>
            </>
          )}
        </Row>
      </div>
    </Wrap>
  );
};

export default Model;
